import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-a188e45c"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "lecture-card"
};
const _hoisted_3 = {
  class: "lecture-card-img"
};
const _hoisted_4 = {
  class: "lecture-type"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  key: 0,
  class: "address"
};
const _hoisted_7 = {
  class: "lecture-card-content"
};
const _hoisted_8 = {
  class: "lecture-card-title"
};
const _hoisted_9 = {
  class: "lecture-start-time"
};
const _hoisted_10 = {
  key: 0,
  class: "lecture-card-teacher"
};
const _hoisted_11 = {
  class: "teacher-icon-list"
};
const _hoisted_12 = {
  class: "avatar-stack"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  class: "avatar-overlay"
};
const _hoisted_15 = {
  class: "overlay-text"
};
const _hoisted_16 = {
  class: "teacher-name-box"
};
const _hoisted_17 = {
  class: "teacher-name"
};
const _hoisted_18 = {
  class: "teacher-school"
};
import { getUrlParams } from '@/plugins/utils';
export default {
  props: {
    finishLecture: Object,
    index: Number
  },

  setup(__props) {
    const props = __props;
    const $baseUrl = inject('$baseUrl');
    const menuInfo = reactive({
      menuId: getUrlParams('menuId'),
      menuName: getUrlParams('name')
    });
    const defaultCover = computed(() => {
      if (props.finishLecture.type == 1) {
        return props.index < 2 ? `lecture_online${props.index + 1}` : `lecture_online${props.index % 2 + 1}`;
      } else {
        return props.index < 2 ? `lecture_offline${props.index + 1}` : `lecture_offline${props.index % 2 + 1}`;
      }
    }); // 教师显示

    const formatSchool = () => {
      const item = props.finishLecture.teacherDtoList.find(item => item.school_name);
      const length = props.finishLecture.teacherDtoList.length;
      let schoolName = item && item.school_name ? item.school_name : '';

      if (length > 1) {
        return schoolName + `等${length}个机构`;
      } else {
        return schoolName || '';
      }
    }; // 教师显示


    const formatTeacher = () => {
      const {
        teacher_name,
        school_name,
        job_title,
        college_name
      } = props.finishLecture.teacherDtoList[0];
      const length = props.finishLecture.teacherDtoList.length;

      if (length > 1) {
        return teacher_name + `等${length}名老师`;
      } else {
        return teacher_name + (!(school_name && college_name && job_title) ? '' : ' | ' + (school_name || '') + (college_name || ''));
      }
    };

    return (_ctx, _cache) => {
      const _component_el_divider = _resolveComponent("el-divider");

      return _openBlock(), _createElementBlock("a", {
        href: `${_unref($baseUrl)}/lectureDetail.html?menuId=${_unref(menuInfo).menuId}&name=${_unref(menuInfo).menuName}&id=${__props.finishLecture.id}`
      }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(__props.finishLecture.type == 1 ? '线上直播' : '线下活动'), 1), _createElementVNode("img", {
        src: __props.finishLecture.live_cover_url || require(`@/assets/images/lecture/${_unref(defaultCover)}.png`),
        alt: "",
        class: "lecture-img"
      }, null, 8, _hoisted_5), __props.finishLecture.type != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(__props.finishLecture.address), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.finishLecture.live_name), 1), _createElementVNode("div", _hoisted_9, "活动时间：" + _toDisplayString(__props.finishLecture.start_time), 1), _createVNode(_component_el_divider), __props.finishLecture.teacherDtoList && __props.finishLecture.teacherDtoList.length ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.finishLecture.teacherDtoList.slice(0, 3), (item, index) => {
        return _openBlock(), _createElementBlock("img", {
          src: item.file_url || require('@/assets/images/common/teacher_icon.png'),
          alt: "",
          class: "teacher-icon",
          key: index,
          style: _normalizeStyle({
            zIndex: __props.finishLecture.teacherDtoList.length - index
          })
        }, null, 12, _hoisted_13);
      }), 128)), __props.finishLecture.teacherDtoList.length > 3 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("span", _hoisted_15, "+" + _toDisplayString(__props.finishLecture.teacherDtoList.length - 3), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(formatTeacher()), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(formatSchool()), 1)])])) : _createCommentVNode("", true)])])], 8, _hoisted_1);
    };
  }

};